import axios from '@/axios'
import * as types from '../mutation-types'
import { eStorage } from '@beetronix/estorage'
import { actionType, permission } from '@/helpers/enums'
export default {
	namespaced: true,

	state: {
		self: {
			username: null,
			userId: null,
			isAdmin: false,
			permissions: {
				sales: {},
				inventory: {},
				items: {},
				users: {},
				accounts: {},
				purchases: {},
				purchasesSimulation: {},
				receives: {},
				statistics: {},
				fiscalYears: {},
				materialJournal: {},
				managingSettings: {},
				managingProductionOrders: {},
				managingOrderResults: {},
				managingItemsStatement: {},
				managingExperimentalSimulation: {},
				managingMaterialSimulation: {},
				managingReceivingJournals: {},
				managingDeliveryJournals: {}
			},
		},
		isAuthorized: false,
	},

	actions: {
		fetchPermissions({ commit }) {
			return axios.get('/role/self').then(({ permissions }) => {
				commit(types.STORE_USER_PERMISSIONS, permissions);
				return permissions;
			})
		},
		
		login({ commit }, { username, password }) {
			return axios.post('/user/authenticate', { email: '', username, password }).then(data => {
				const auth = {
					token: data.token,
					username: data.username,
					roleId: data.roleId,
					userId: data.id
				}
				commit(types.LOGIN, auth);
				axios.defaults.headers.common.Authorization = `Bearer ${auth.token}`;
			})
		},
		
		logout({ commit }) {
			commit(types.LOGOUT);
		},

		reset({ commit }) {
			commit(types.RESET);
		}
	},

	mutations: {
		[types.LOGIN](state, auth) {
			state.self.username = auth.username;
			state.self.roleId = auth.roleId;
			state.self.userId = auth.userId;
			state.isAuthorized = true;
			eStorage.l.set('auth', auth);
		},
		[types.STORE_USER_PERMISSIONS](state, permissions) {
			let isAdmin = true;
			const permissionsKeys = [
				{ key: 'sales', typeId: permission.sales },
				{ key: 'inventory', typeId: permission.managingInventory },
				{ key: 'items', typeId: permission.managingItems },
				{ key: 'users', typeId: permission.managingUsers },
				{ key: 'accounts', typeId: permission.managingAccounts },
				{ key: 'purchases', typeId: permission.managingPurchases },
				{ key: 'purchasesSimulation', typeId: permission.managingSimulations },
				{ key: 'receives', typeId: permission.managingReceives },
				{ key: 'statistics', typeId: permission.viewStatistics },
				{ key: 'fiscalYears', typeId: permission.fiscalYears },
				{ key: 'materialJournal', typeId: permission.materialJournal },
				{ key: 'managingSettings', typeId: permission.managingSettings },
				{ key: 'managingProductionOrders', typeId: permission.managingProductionOrders },
				{ key: 'managingOrderResults', typeId: permission.managingOrderResults },
				{ key: 'managingItemsStatement', typeId: permission.managingItemsStatement },
				{ key: 'managingExperimentalSimulation', typeId: permission.managingExperimentalSimulation },
				{ key: 'managingMaterialSimulation', typeId: permission.managingMaterialSimulation },
				{ key: 'managingReceivingJournals', typeId: permission.managingReceivingJournals },
				{ key: 'managingDeliveryJournals', typeId: permission.managingDeliveryJournals }
			];
			// managingProductionOrders
			permissionsKeys.forEach(c => {
				const permissionObj = permissions.find(e => e.permissionsNames === c.typeId);
				state.self.permissions[c.key] = {
					isReadWrite:
						permissionObj ? permissionObj.rolePermissions === actionType.readAndWrite : false,
					isReadonly:
						permissionObj ? permissionObj.rolePermissions === actionType.read : false,
					isNone:
						permissionObj ? permissionObj.rolePermissions === actionType.none : true,
				}

				if (
					!permissionObj || 
					(permissionObj && permissionObj.rolePermissions !== actionType.readAndWrite)
				) {
					isAdmin = false;
				}
			});
			state.self.isAdmin = isAdmin;
		},
		[types.LOGOUT](state, auth) {
			state.self.username = null;
			state.self.roleId = null;
			state.self.userId = null;
			state.isAuthorized = false;
			delete axios.defaults.headers.common.Authorization;
			eStorage.l.remove('auth', auth);

			state.self.permissions.isAdmin = false;
			state.self.permissions.sales = {};
			state.self.permissions.inventory = {};
			state.self.permissions.items = {};
			state.self.permissions.users = {};
			state.self.permissions.accounts = {};
			state.self.permissions.purchases = {};
			state.self.permissions.purchasesSimulation = {};
			state.self.permissions.receives = {};
			state.self.permissions.statistics = {};
			state.self.permissions.fiscalYears = {};
			state.self.permissions.materialJournal = {};
			state.self.permissions.managingSettings = {};
			state.self.permissions.managingProductionOrders = {};
			state.self.permissions.managingOrderResults = {};
			state.self.permissions.managingItemsStatement = {};
			state.self.permissions.managingExperimentalSimulation = {};
			state.self.permissions.managingMaterialSimulation = {};
			state.self.permissions.managingReceivingJournals = {};
			state.self.permissions.managingDeliveryJournals = {};
		},
		[types.RESET](state) {
			state.self.permissions.isAdmin = false;
			state.self.permissions.sales = {};
			state.self.permissions.inventory = {};
			state.self.permissions.items = {};
			state.self.permissions.users = {};
			state.self.permissions.accounts = {};
			state.self.permissions.purchases = {};
			state.self.permissions.purchasesSimulation = {};
			state.self.permissions.receives = {};
			state.self.permissions.statistics = {};
			state.self.permissions.fiscalYears = {};
			state.self.permissions.materialJournal = {};
			state.self.permissions.managingSettings = {};
			state.self.permissions.managingProductionOrders = {};
			state.self.permissions.managingOrderResults = {};
			state.self.permissions.managingItemsStatement = {};
			state.self.permissions.managingExperimentalSimulation = {};
			state.self.permissions.managingMaterialSimulation = {};
			state.self.permissions.managingReceivingJournals = {};
			state.self.permissions.managingDeliveryJournals = {};
		}
	},
}